import Link from "next/link";

export const fragenAutoExport = [
  {
    question: "Was bedeutet Autoexport?",
    answer: (
      <>
        <p>
          Autoexport bedeutet, dass ein Fahrzeug ins Ausland verkauft wird.
          Dabei wird das Auto entweder von einem Händler oder einem privaten
          Käufer gekauft, der es in einem anderen Land nutzen oder
          weiterverkaufen möchte. Fahrzeuge, die in Österreich nicht mehr
          gefragt oder aufgrund von Alter, Laufleistung oder Schäden schwer zu
          verkaufen sind, finden oft auf internationalen Märkten noch Abnehmer.
        </p>

        <p>
          Ein professioneller Dienstleister wie Autoeinfachlos übernimmt dabei
          den gesamten Prozess – von der Käufervermittlung über den Papierkram
          bis hin zur Abholung – und macht den Autoexport für dich schnell und
          unkompliziert.
        </p>
      </>
    ),
  },
  {
    question: "Wie funktioniert der Auto-Export?",
    answer: (
      <>
        <p>
          Der Auto-Export ist ein einfacher und klar strukturierter Prozess,
          wenn du ihn mit einem professionellen Anbieter wie Autoeinfachlos
          durchführst. Hier sind die Schritte:
        </p>

        <ol className="AV-Fragen-ol">
          <li>
            <strong>Bewertung deines Autos</strong>
            <br />
            Gib online die Daten deines Fahrzeugs ein, und wir ermitteln in
            wenigen Minuten den aktuellen Marktwert – kostenlos und
            unverbindlich.
          </li>
          <li>
            <strong>Händlernetzwerk bietet auf dein Auto</strong>
            <br />
            Über 5.000 Händler aus unserem Netzwerk bieten auf dein Fahrzeug, um
            den besten Preis für dich zu erzielen.
          </li>
          <li>
            <strong>Angebot annehmen</strong>
            <br />
            Sobald du das beste Angebot ausgewählt hast, geht es weiter. Es gibt
            keine versteckten Kosten oder Verpflichtungen.
          </li>
          <li>
            <strong>Abholung und Bezahlung </strong>
            <br />
            Wir holen dein Auto kostenlos direkt bei dir ab. Die Bezahlung
            erfolgt sicher und schnell per Banküberweisung.
          </li>
        </ol>

        <p>
          Mit Autoeinfachlos ist der Autoexport-Verkauf unkompliziert, sicher
          und transparent – ohne Papierkram oder Risiken. Du musst dich um
          nichts kümmern, wir übernehmen den gesamten Ablauf für dich.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich mein Auto auch mit Schäden oder Defekten exportieren?",
    answer: (
      <>
        <p>
          Ja, bei Autoeinfachlos kannst du dein Auto auch mit Schäden oder
          Defekten problemlos exportieren. Unser Service akzeptiert Fahrzeuge in
          jedem Zustand – egal ob Unfallschaden, Motorschaden oder hoher
          Kilometerstand.
        </p>

        <p>
          Selbst nicht fahrbereite Autos oder Fahrzeuge ohne gültiges Pickerl
          sind kein Problem. Dank unseres Netzwerks von über 5.000
          internationalen Händlern finden wir auch für defekte Fahrzeuge den
          besten Preis.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich mein Auto auch ohne Pickerl exportieren?",
    answer: (
      <>
        <p>
          Ja, du kannst dein Auto auch ohne gültiges Pickerl problemlos
          exportieren. Bei Autoeinfachlos akzeptieren wir Fahrzeuge unabhängig
          von ihrem Zustand oder ihrer Zulassung. Ein fehlendes oder
          abgelaufenes Pickerl stellt kein Hindernis dar.
        </p>
      </>
    ),
  },
  {
    question: "Wo kann ich mein Auto für den Export in meiner Nähe verkaufen?",
    answer: (
      <>
        <p>
          Mit Autoeinfachlos kannst du dein Auto für den Export direkt und
          bequem von deinem Wohnort aus verkaufen – ganz ohne, dass du eine
          Filiale besuchen musst. Unser Service ist komplett online: Du gibst
          die Fahrzeugdaten ein, erhältst eine kostenlose Bewertung und wir
          kümmern uns um den Rest.
        </p>

        <p>
          Dank unserer kostenlosen Abholung musst du dich nicht darum kümmern,
          dein Auto selbst irgendwohin zu bringen. Egal, wo du dich in
          Österreich befindest – mit Autoeinfachlos ist der Auto export
          verkaufen unkompliziert, sicher und direkt in deiner Nähe möglich.
        </p>
      </>
    ),
  },
  {
    question: "Was ist mein Auto bei einem Auto Export wert?",
    answer: (
      <>
        <p>
          Den Wert deines Autos beim Export kannst du mit unserem kostenlosen
          Bewertungstool ganz einfach online ermitteln. In wenigen Minuten
          erhältst du eine erste Einschätzung des Marktwerts deines Fahrzeugs.
        </p>

        <p>
          Im nächsten Schritt startet eine Auktion, bei der über 5.000 Händler
          auf dein Auto bieten. So wird der tatsächliche Verkaufspreis ermittelt
          – und du kannst selbst entscheiden, ob du das Angebot annehmen
          möchtest oder nicht.
        </p>

        <p>
          Mit Autoeinfachlos bist du immer auf der sicheren Seite und erzielst
          den besten Preis für dein Fahrzeug.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich für den Autoexport?",
    answer: (
      <>
        <p>
          Für den Autoexport benötigst du im Grunde dieselben Unterlagen wie
          beim Fahrzeugverkauf. Dazu gehören:
        </p>
        <ul className="AV-Fragen-ul">
          <li>
            <strong>Zulassungsbescheinigung Teil 1</strong>
          </li>
          <li>
            <strong>Zulassungsbescheinigung Teil 2</strong>
          </li>
          <li>
            <strong>Kaufvertrag</strong> (Keine Sorge, den übernehmen wir für
            dich!)
          </li>
        </ul>
        <br />

        <p>
          Für alle weiteren Details und hilfreiche Tipps schau einfach in
          unserem{" "}
          <Link href="/faq" className="FragenAntworten-link ">
            Hilfezentrum
          </Link>{" "}
          vorbei. Dort findest du alles, was du für deinen Export wissen musst!
        </p>
      </>
    ),
  },
  {
    question: "Wie lange dauert der Verkaufsprozess beim Autoexport?",
    answer: (
      <>
        <p>
          Der Verkaufsprozess beim Autoexport ist schnell und einfach – in nur
          drei Schritten ist alles erledigt:
        </p>
        <ol className="AV-Fragen-ol">
          <li>
            <strong>Sofortbewertung erhalten: </strong>
            Innerhalb weniger Minuten erfährst du den geschätzten Wert deines
            Fahrzeugs.
          </li>
          <li>
            <strong>Den besten Verkaufspreis erhalten: </strong>
            Händler haben 24 Stunden Zeit, um sich gegenseitig zu überbieten und
            so den besten Preis für dein Auto zu erzielen.
          </li>{" "}
          <li>
            <strong>Abholung und Bezahlung: </strong>
            In 48-72 Stunden wird dein Fahrzeug abgeholt, und du erhältst direkt
            dein Geld.
          </li>
        </ol>
        <br />

        <p>Effizienter und bequemer geht es kaum!</p>
      </>
    ),
  },
  {
    question: "Fallen beim Autoexport zusätzliche Kosten an?",
    answer: (
      <>
        <p>
          Nein, unser Service ist für dich komplett kostenlos! Vom ersten
          Schritt der Bewertung bis zur Abholung und Bezahlung entstehen dir
          keinerlei Kosten. Du kannst dich zurücklehnen, während wir uns um
          alles kümmern.
        </p>
      </>
    ),
  },
  {
    question:
      "Kann ich den Verkauf jederzeit abbrechen, wenn ich es mir anders überlege?",
    answer: (
      <>
        <p>
          Ja, natürlich! Du kannst den Verkauf jederzeit abbrechen, falls du es
          dir anders überlegst. Unser Service ist völlig unverbindlich, und du
          behältst die volle Kontrolle über den Prozess.
        </p>
      </>
    ),
  },
];
